"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLengthInputValue = void 0;
/** Keep numeric inputs within their configured range, in the displayed units. */
function clampNumberInput(value, min, max) {
    if (Number(value) > max) {
        return max.toString();
    }
    if (Number(value) < min) {
        return min.toString();
    }
    return value;
}
exports.default = clampNumberInput;
/** Preserve positive partial edits while applying bounded values to the model. */
function getLengthInputValue(input, min, max, precision = 3) {
    var _a, _b;
    const numericValue = (_b = (_a = input.match(/-?[0-9]+\.?[0-9]{0,3}/)) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : '';
    const indexOfPoint = numericValue.lastIndexOf('.');
    const decimals = indexOfPoint === -1 ? 0 : numericValue.length - indexOfPoint - 1;
    const value = clampNumberInput(Number(numericValue).toFixed(Math.min(decimals, precision)), min, max);
    const draft = Number(numericValue) > 0 && Number(numericValue) < min ? numericValue : value;
    return { draft, value };
}
exports.getLengthInputValue = getLengthInputValue;
